import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import React from "react";
import { FormularioDevolucionMonto } from "./FormularioDevolucionMonto";

export const ModalDevolucionMonto = (props) => {
  return (
    <Dialog
      fullWidth
      maxWidth={"sm"}
      open={props.open}
      // onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        <h2
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0",
          }}
        >
          <Typography variant="h6">Devolución Monto</Typography>
          <Typography variant="h6">
            {props.usuarioTurnoSeleccionado?.afiliado?.apellido_y_nombre}
          </Typography>
        </h2>
      </DialogTitle>
      <DialogContent>
        <FormularioDevolucionMonto
          usuarioTurnoSeleccionado={props.usuarioTurnoSeleccionado}
          closeModalDevolucionMonto={props.onClose}
          monto={props.monto}
          idAgenda={props.idAgenda}
          idObraSocial={props.idObraSocial}
        />
      </DialogContent>
    </Dialog>
  );
};
